<template>
	<span class="block w-full flex flex-col justify-center h1">
		<span class="block">
      <h1 class="inline home-hero-heading">Find your <i>dream home</i></h1>
			<transition name="community-name" mode="out-in">
				<span class="community-name" key="in" v-if="preposition == 'in'">in</span>
				<span class="community-name" key="on" v-else>on</span>
			</transition>
		</span>
		<transition
			name="community-name"
			mode="out-in"
			@before-enter="beforeEnter"
			@enter="enter"
			@after-enter="afterEnter"
			@before-leave="beforeLeave"
			@leave="leave"
			:duration="{ enter: 750, leave: 500 }"
		>
			<span class="community-name block font-bold" :key="communityIndex" v-if="activeCommunity">
				<span ref="wrapper" class="inline-block">{{ activeCommunity.title }}</span>
			</span>
		</transition>
	</span>
</template>

<script>
	// Animates the rotating community name in the residential homepage hero.
	export default {
		props: {
			communities: { type: Array, default: () => [] },
			communityIndex: { type: Number, default: 0 },
		},
		data() {
			return {
				lastWidth: null,
				currentWidth: null
			};
		},
		computed: {
			activeCommunity() {
				return this.communities[this.communityIndex];
			},
			preposition() {
				var community = this.activeCommunity;
				if (community && community.title.includes("Lake")) {
					return "on";
				} else {
					return "in";
				}
			}
		},
		methods: {
			beforeEnter(element) {
				element.style.opacity = "0";
				element.style.height = this.lastHeight;
			},
			enter(element) {
				setTimeout(() => {
					const wrapper = Array.isArray(this.$refs.wrapper)
						? this.$refs.wrapper[0]
						: this.$refs.wrapper;
					element.style.opacity = "1";
					if (wrapper) {
						element.style.height = wrapper.getBoundingClientRect().height + "px";
					}
				}, 50);
			},
			afterEnter(element) {
				element.style.height = "auto";
			},
			beforeLeave(element) {
				this.lastHeight = getComputedStyle(element).height;
			},
			leave(element) {
				element.style.opacity = "0";
			}
		}
	};
</script>
